import React, { useState, useEffect } from "react";

import { withCars } from "../../../shared/containers/containerCars";
import { withSelectedCars } from "../../../shared/containers/containerSelectedCars";
import { withSelectedReports } from "../../../shared/containers/containerSelectedReports";

import CarsCheckbox from "../../../shared/items/contols/carCheckbox";

import { getColor } from "./static.reportsColors";

const handleClick = (props, isChecked) => {
  const { listUnits, selectedCars, onChangeSelectedCar, selectedReports } = props;
  let updatedCars = [...selectedCars];
  
  if (!isChecked) {
    listUnits.forEach((item) => {
      let isSelected = updatedCars.find((selectedItem) => selectedItem.id === item.id);

      if (!isSelected) {
        if (
          item.reports.some((x) => {
            return selectedReports.length === 0 || x.id === selectedReports[0].id;
          })
        ) {
          updatedCars.push({
            id: item.id,
            title: item.unit.title,
            registerNumber: item.unit.registerNumber,
            color: getColor(updatedCars),
            reports: item.reports,
          });
        }
      }
    });

    onChangeSelectedCar(updatedCars);
  } else {
    let isUnselected = (item) => !listUnits.find((selectedItem) => selectedItem.id === item.id);

    onChangeSelectedCar(updatedCars.filter(isUnselected));
  }
};

const SelectAllselectedCars = (props) => {
  const { listUnits, selectedCars } = props;
  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    if (selectedCars.length > 0) {
      let isUnitSelected = (item) => selectedCars.find((selectedItem) => selectedItem.id === item.id);
      let isUnitsSelected = listUnits.every(isUnitSelected);
      setChecked(isUnitsSelected);
    } else {
      setChecked(false);
    }
  }, [selectedCars, listUnits]);

  return <CarsCheckbox checked={isChecked} changeReportCar={handleClick.bind(this, props, isChecked)} />;
};

export default withSelectedReports(withSelectedCars(withCars(React.memo(SelectAllselectedCars))));
